import { GetServerSideProps } from 'next';
import { PageRendererComponent, prePageCall, useSession } from '@marriott/mi-headless-utils';
import { mockModel } from '../mocks/mockModel';
import { envVarKeys } from '../constants/envVarKeys';
import { useEffect } from 'react';
import operationSignatures from '../constants/operationSignatures.json';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

function pageRenderer(props) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { updateDatalayer } = useSession();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    updateDatalayer({
      event: 'PAGEVIEW', // provide relevant event name
      USER: { userLoggedIn: 'unauthenticated' },
      METADATA: { site_id: 'Luxury', env_gdpr: true, env_ccpa: true, env_marketing: true },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);
  }, []);
  return <PageRendererComponent {...props} />;
}

const {
  NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
  NEXT_PUBLIC_SUBMIT_SEARCH_URL,
  NEXT_PUBLIC_APP_NAME,
  BAIDU_MAP_API_KEY,
  GOOGLE_MAP_API_KEY,
} = process.env;

/**
 * To skip MVP Offers call in ACDL
 */
const SKIP_MVP_OFFERS = true;

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const luxurySpecificData = async () => {
  //Feature flag call for logo
  const featureFlagLogo = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
    target: TARGETS.APP.LUXURY_RENDERER,
  });
  return {
    NEXT_PUBLIC_SUBMIT_SEARCH_URL,
    NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
    NEXT_PUBLIC_APP_NAME,
    BAIDU_MAP_API_KEY,
    GOOGLE_MAP_API_KEY,
    operationSignatures: operationSignatures,
    nextPublicEnvKeys: [...Object.keys(envVarKeys)],
    featureFlagLogo,
    SKIP_MVP_OFFERS,
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps = prePageCall(luxurySpecificData, mockModel);
export default pageRenderer;
